import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string()
    .matches(
      /^[^<>:;,?"*|/]+$/,
      'Invalid characters. Avoid < > : ; , ? " * | /',
    )
    .required('Assessment name is required'),
  standard: Yup.string().required('Please select a standard'),
  // gradeSheets: Yup.string(),
});